import { ProCard } from '@ant-design/pro-components'
import { db } from '@app/icare/client/db'
import { localResultQueryOptions } from '@app/icare/client/db/client/localQueryOptions'
import { queryKit } from '@app/icare/db/query/queryKit'
import type { Station } from '@app/icare/db/schema/common'
import type { ClinicIdType } from '@app/icare/entities/clinic/schema/Clinic'
import { ContactColumn } from '@app/icare/routes/_app/apotheken/-components/ContactColumn'
import { WardEditDrawer } from '@app/icare/routes/_app/kliniken/-components/WardEditDrawer'
import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { CreateButton } from '@pkg/ui/button'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Button, Table } from 'antd'
import type { ColumnType } from 'antd/es/table'
import { useMemo } from 'react'
import { FaPencil } from 'react-icons/fa6'

export const Route = createFileRoute('/_app/kliniken/$id/stations')({
  component: RouteComponent,
})

function RouteComponent() {
  const clinicId = Route.useParams().id as ClinicIdType

  const { data: wards = [] } = useQuery(
    localResultQueryOptions({
      query: db.selectFrom('station').selectAll().where('ownerId', '=', clinicId).$call(queryKit.deleted('exclude')),
    }),
  )

  const columns: ColumnType<Station>[] = useMemo(
    () => [
      {
        key: 'name',
        dataIndex: 'name',
        title: t`Name`,
      },
      {
        key: 'specialization',
        dataIndex: 'specialization',
        title: t`Spezialisierung`,
      },
      {
        key: 'contact',
        width: 250,
        title: 'Kontaktdaten',
        render: (_, input) => <ContactColumn input={input} />,
      },
      {
        key: 'actions',
        width: 80,
        render: (_, ward) => (
          <Button
            type="text"
            size="small"
            icon={<FaPencil />}
            onClick={() => void WardEditDrawer.show({ clinicId, id: ward.id })}
          />
        ),
      },
    ],
    [clinicId],
  )

  return (
    <ProCard headerBordered title="Stationen" className="mx-4">
      <Table rowKey="id" dataSource={wards as Station[]} columns={columns} />
      <CreateButton onClick={() => void WardEditDrawer.show({ clinicId })}>
        <Trans>Station hinzufügen</Trans>
      </CreateButton>
    </ProCard>
  )
}
